import { useState } from 'react';
import { api } from '../../services/api';
import { btn, c } from '../../theme';

// Downloads a Contact Center workbook for exactly what the page is showing.
// Through api.getBlob, not a link: the API needs the signed-in token, and the
// server records every export, with its filter, in the access log.
export default function ExportButton({ path, params, filename }) {
  const [state, setState] = useState(null);
  const run = async () => {
    setState('busy');
    try {
      const qs = new URLSearchParams(Object.entries(params).filter(([, v]) => v != null && v !== '')).toString();
      const blob = await api.getBlob(`${path}?${qs}`);
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      setState(null);
    } catch (err) {
      setState(`Export failed: ${err.message}`);
    }
  };
  return (
    <span>
      <button type="button" onClick={run} disabled={state === 'busy'} style={btn.secondaryXs}>
        {state === 'busy' ? 'Exporting…' : 'Export to Excel'}
      </button>
      {state && state !== 'busy' && <span style={{ fontSize: '12px', color: c.dangerText, marginLeft: '8px' }} role="alert">{state}</span>}
    </span>
  );
}
